import React, { useEffect, useState } from "react";
import "./Banner.css";



// Bandika const translations = { ... }; hapa juu ya Banner
const translations = {
// English
en: {
  welcomeBonus: "Welcome Bonus",
  welcomeBonusSubtitle: "Get 100% Bonus on your First Deposit",
  liveBetting: "Live Betting",
  liveBettingSubtitle: "Bet Live and Win Instantly",
  dailyJackpot: "Daily Jackpot",
  dailyJackpotSubtitle: "Play Every Day and Win Big",
},

// French
fr: {
  welcomeBonus: "Bonus de bienvenue",
  welcomeBonusSubtitle: "Obtenez un bonus de 100 % sur votre premier dépôt",
  liveBetting: "Paris en direct",
  liveBettingSubtitle: "Pariez en direct et gagnez instantanément",
  dailyJackpot: "Jackpot quotidien",
  dailyJackpotSubtitle: "Jouez chaque jour et gagnez gros",
},

// Swahili
sw: {
  welcomeBonus: "Bonasi ya Karibu",
  welcomeBonusSubtitle: "Pata Bonasi ya 100% kwenye Amana Yako ya Kwanza",
  liveBetting: "Kamari ya Moja kwa Moja",
  liveBettingSubtitle: "Cheza Moja kwa Moja na Ushinde Mara Moja",
  dailyJackpot: "Jackpot ya Kila Siku",
  dailyJackpotSubtitle: "Cheza Kila Siku na Ushinde Zawadi Kubwa",
},

// Portuguese
pt: {
  welcomeBonus: "Bônus de Boas-vindas",
  welcomeBonusSubtitle: "Ganhe 100% de bônus no seu primeiro depósito",
  liveBetting: "Apostas ao Vivo",
  liveBettingSubtitle: "Aposte ao vivo e ganhe instantaneamente",
  dailyJackpot: "Jackpot Diário",
  dailyJackpotSubtitle: "Jogue todos os dias e ganhe muito",
},

// Spanish
es: {
  welcomeBonus: "Bono de bienvenida",
  welcomeBonusSubtitle: "Obtén un bono del 100% en tu primer depósito",
  liveBetting: "Apuestas en vivo",
  liveBettingSubtitle: "Apuesta en vivo y gana al instante",
  dailyJackpot: "Jackpot diario",
  dailyJackpotSubtitle: "Juega todos los días y gana a lo grande",
},

// Arabic
ar: {
  welcomeBonus: "مكافأة الترحيب",
  welcomeBonusSubtitle: "احصل على مكافأة بنسبة 100% عند أول إيداع",
  liveBetting: "المراهنات المباشرة",
  liveBettingSubtitle: "راهن مباشرة واربح فورًا",
  dailyJackpot: "الجائزة الكبرى اليومية",
  dailyJackpotSubtitle: "العب كل يوم واربح جوائز كبيرة",
},

// Chinese
zh: {
  welcomeBonus: "欢迎奖金",
  welcomeBonusSubtitle: "首次存款即可获得 100% 奖金",
  liveBetting: "实时投注",
  liveBettingSubtitle: "实时投注，即刻赢奖",
  dailyJackpot: "每日大奖",
  dailyJackpotSubtitle: "每天参与，赢取丰厚奖励",
},

// Hindi
hi: {
  welcomeBonus: "स्वागत बोनस",
  welcomeBonusSubtitle: "पहली जमा राशि पर 100% बोनस पाएँ",
  liveBetting: "लाइव बेटिंग",
  liveBettingSubtitle: "लाइव दाँव लगाएँ और तुरंत जीतें",
  dailyJackpot: "दैनिक जैकपॉट",
  dailyJackpotSubtitle: "हर दिन खेलें और बड़ा जीतें",
},

// Bengali
bn: {
  welcomeBonus: "স্বাগতম বোনাস",
  welcomeBonusSubtitle: "প্রথম জমায় ১০০% বোনাস পান",
  liveBetting: "লাইভ বেটিং",
  liveBettingSubtitle: "লাইভ বাজি ধরুন এবং সঙ্গে সঙ্গে জিতুন",
  dailyJackpot: "দৈনিক জ্যাকপট",
  dailyJackpotSubtitle: "প্রতিদিন খেলুন এবং বড় পুরস্কার জিতুন",
},

// Russian
ru: {
  welcomeBonus: "Приветственный бонус",
  welcomeBonusSubtitle: "Получите бонус 100% на первый депозит",
  liveBetting: "Ставки в реальном времени",
  liveBettingSubtitle: "Ставьте в прямом эфире и выигрывайте мгновенно",
  dailyJackpot: "Ежедневный джекпот",
  dailyJackpotSubtitle: "Играйте каждый день и выигрывайте по-крупному",
},

// German
de: {
  welcomeBonus: "Willkommensbonus",
  welcomeBonusSubtitle: "Erhalte 100 % Bonus auf deine erste Einzahlung",
  liveBetting: "Live-Wetten",
  liveBettingSubtitle: "Wette live und gewinne sofort",
  dailyJackpot: "Täglicher Jackpot",
  dailyJackpotSubtitle: "Spiele jeden Tag und gewinne groß",
},

// Italian
it: {
  welcomeBonus: "Bonus di benvenuto",
  welcomeBonusSubtitle: "Ricevi un bonus del 100% sul primo deposito",
  liveBetting: "Scommesse live",
  liveBettingSubtitle: "Scommetti dal vivo e vinci subito",
  dailyJackpot: "Jackpot giornaliero",
  dailyJackpotSubtitle: "Gioca ogni giorno e vinci alla grande",
},

// Dutch
nl: {
  welcomeBonus: "Welkomstbonus",
  welcomeBonusSubtitle: "Ontvang 100% bonus op je eerste storting",
  liveBetting: "Live wedden",
  liveBettingSubtitle: "Wed live en win direct",
  dailyJackpot: "Dagelijkse jackpot",
  dailyJackpotSubtitle: "Speel elke dag en win groots",
},

// Turkish
tr: {
  welcomeBonus: "Hoş Geldin Bonusu",
  welcomeBonusSubtitle: "İlk yatırımında %100 bonus kazan",
  liveBetting: "Canlı Bahis",
  liveBettingSubtitle: "Canlı bahis yap ve anında kazan",
  dailyJackpot: "Günlük Büyük Ödül",
  dailyJackpotSubtitle: "Her gün oyna ve büyük kazan",
},

// Japanese
ja: {
  welcomeBonus: "ウェルカムボーナス",
  welcomeBonusSubtitle: "初回入金で100%ボーナスを獲得",
  liveBetting: "ライブベッティング",
  liveBettingSubtitle: "ライブで賭けてすぐに勝利",
  dailyJackpot: "デイリージャックポット",
  dailyJackpotSubtitle: "毎日プレイして大きく勝とう",
},

// Korean
ko: {
  welcomeBonus: "환영 보너스",
  welcomeBonusSubtitle: "첫 입금 시 100% 보너스 받기",
  liveBetting: "라이브 베팅",
  liveBettingSubtitle: "실시간으로 베팅하고 즉시 승리하세요",
  dailyJackpot: "일일 잭팟",
  dailyJackpotSubtitle: "매일 플레이하고 큰 상금을 받으세요",
},

// Vietnamese
vi: {
  welcomeBonus: "Tiền thưởng chào mừng",
  welcomeBonusSubtitle: "Nhận thưởng 100% cho lần nạp đầu tiên",
  liveBetting: "Cá cược trực tiếp",
  liveBettingSubtitle: "Cược trực tiếp và thắng ngay lập tức",
  dailyJackpot: "Jackpot hằng ngày",
  dailyJackpotSubtitle: "Chơi mỗi ngày và thắng lớn",
},

// Thai
th: {
  welcomeBonus: "โบนัสต้อนรับ",
  welcomeBonusSubtitle: "รับโบนัส 100% สำหรับการฝากครั้งแรก",
  liveBetting: "เดิมพันสด",
  liveBettingSubtitle: "เดิมพันสดและรับชัยชนะทันที",
  dailyJackpot: "แจ็กพอตรายวัน",
  dailyJackpotSubtitle: "เล่นทุกวันและลุ้นรางวัลใหญ่",
},

// Indonesian
id: {
  welcomeBonus: "Bonus Selamat Datang",
  welcomeBonusSubtitle: "Dapatkan bonus 100% pada deposit pertama",
  liveBetting: "Taruhan Langsung",
  liveBettingSubtitle: "Bertaruh langsung dan menang seketika",
  dailyJackpot: "Jackpot Harian",
  dailyJackpotSubtitle: "Bermain setiap hari dan raih kemenangan besar",
},

// Malay
ms: {
  welcomeBonus: "Bonus Selamat Datang",
  welcomeBonusSubtitle: "Dapatkan bonus 100% untuk deposit pertama anda",
  liveBetting: "Pertaruhan Langsung",
  liveBettingSubtitle: "Bertaruh secara langsung dan menang serta-merta",
  dailyJackpot: "Jackpot Harian",
  dailyJackpotSubtitle: "Bermain setiap hari dan menang besar",
},

// Urdu
ur: {
  welcomeBonus: "خوش آمدیدی بونس",
  welcomeBonusSubtitle: "اپنی پہلی رقم جمع کرنے پر 100% بونس حاصل کریں",
  liveBetting: "لائیو بیٹنگ",
  liveBettingSubtitle: "لائیو شرط لگائیں اور فوراً جیتیں",
  dailyJackpot: "روزانہ جیک پاٹ",
  dailyJackpotSubtitle: "ہر روز کھیلیں اور بڑی جیت حاصل کریں",
},

// Persian
fa: {
  welcomeBonus: "پاداش خوش‌آمدگویی",
  welcomeBonusSubtitle: "با اولین واریز خود ۱۰۰٪ پاداش دریافت کنید",
  liveBetting: "شرط‌بندی زنده",
  liveBettingSubtitle: "زنده شرط ببندید و فوراً برنده شوید",
  dailyJackpot: "جک‌پات روزانه",
  dailyJackpotSubtitle: "هر روز بازی کنید و جوایز بزرگ ببرید",
},

// Hausa
ha: {
  welcomeBonus: "Kyautar Maraba",
  welcomeBonusSubtitle: "Sami ƙarin 100% a ajiyar kuɗinka na farko",
  liveBetting: "Caca Kai Tsaye",
  liveBettingSubtitle: "Yi caca kai tsaye ka ci nan take",
  dailyJackpot: "Babbar Kyauta ta Kullum",
  dailyJackpotSubtitle: "Yi wasa kowace rana ka ci babbar kyauta",
},

// Yoruba
yo: {
  welcomeBonus: "Ẹ̀bùn Ìkíni",
  welcomeBonusSubtitle: "Gba ẹ̀bùn 100% lórí ìfipamọ́ owó àkọ́kọ́ rẹ",
  liveBetting: "Tẹtẹ Lójúfò",
  liveBettingSubtitle: "Tẹtẹ lójúfò kí o sì ṣẹ́gun lẹ́sẹ̀kẹsẹ̀",
  dailyJackpot: "Jackpot Ojoojúmọ́",
  dailyJackpotSubtitle: "Ṣeré lójoojúmọ́ kí o sì ṣẹ́gun púpọ̀",
},

// Zulu
zu: {
  welcomeBonus: "Ibhonasi Yokwamukela",
  welcomeBonusSubtitle: "Thola ibhonasi engu-100% lapho ufaka imali okokuqala",
  liveBetting: "Ukubheja Bukhoma",
  liveBettingSubtitle: "Bheja bukhoma futhi uwine ngokushesha",
  dailyJackpot: "Umklomelo Omkhulu Wansuku Zonke",
  dailyJackpotSubtitle: "Dlala nsuku zonke futhi uwine kakhulu",
},

// Amharic
am: {
  welcomeBonus: "የእንኳን ደህና መጡ ቦነስ",
  welcomeBonusSubtitle: "በመጀመሪያ ተቀማጭዎ 100% ቦነስ ያግኙ",
  liveBetting: "ቀጥታ ውርርድ",
  liveBettingSubtitle: "በቀጥታ ይወራረዱ እና ወዲያውኑ ያሸንፉ",
  dailyJackpot: "የዕለት ተዕለት ጃክፖት",
  dailyJackpotSubtitle: "በየቀኑ ይጫወቱ እና ትልቅ ያሸንፉ",
},

// Somali
so: {
  welcomeBonus: "Gunnada Soo Dhaweynta",
  welcomeBonusSubtitle: "Hel gunno 100% ah markaad lacag dhigato markii ugu horreysay",
  liveBetting: "Khamaarka Tooska ah",
  liveBettingSubtitle: "Si toos ah u sharad oo isla markiiba guulayso",
  dailyJackpot: "Jackpot Maalinle ah",
  dailyJackpotSubtitle: "Maalin kasta ciyaar oo guulo waaweyn hel",
},

// Kinyarwanda
rw: {
  welcomeBonus: "Agahimbazamusyi ko Kwakira",
  welcomeBonusSubtitle: "Bona agahimbazamusyi ka 100% ku mafaranga ushyizemo bwa mbere",
  liveBetting: "Gutega Imikino Ako Kanya",
  liveBettingSubtitle: "Tega ako kanya kandi utsinde ako kanya",
  dailyJackpot: "Jackpot ya Buri Munsi",
  dailyJackpotSubtitle: "Kina buri munsi utsindire ibihembo byinshi",
},

// Luganda
lg: {
  welcomeBonus: "Ekirabo eky'Okusanyusa Abapya",
  welcomeBonusSubtitle: "Funa ekirabo kya 100% ku ssente z'oteekamu omulundi ogusooka",
  liveBetting: "Okuteebereza mu Butereevu",
  liveBettingSubtitle: "Teebereza mu butereevu ofune obuwanguzi amangu",
  dailyJackpot: "Jackpot ya Buli Lunaku",
  dailyJackpotSubtitle: "Zannya buli lunaku ofune obuwanguzi obunene",
},

// Afrikaans
af: {
  welcomeBonus: "Welkomsbonus",
  welcomeBonusSubtitle: "Kry 100% bonus op jou eerste deposito",
  liveBetting: "Regstreekse Weddery",
  liveBettingSubtitle: "Wed regstreeks en wen onmiddellik",
  dailyJackpot: "Daaglikse Jackpot",
  dailyJackpotSubtitle: "Speel elke dag en wen groot",
},
};

const banners = [
  {
    id: 1,
    titleKey: "welcomeBonus",
    subtitleKey: "welcomeBonusSubtitle",
    image:
      "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=1200",
  },
  {
    id: 2,
    titleKey: "liveBetting",
    subtitleKey: "liveBettingSubtitle",
    image:
      "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1200",
  },
  {
    id: 3,
    titleKey: "dailyJackpot",
    subtitleKey: "dailyJackpotSubtitle",
    image:
      "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=1200",
  },
];

const Banner = () => {
  const [index, setIndex] = useState(0);

  // LANGUAGE
  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(localStorage.getItem("language") || "en");
    };

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const t = translations[language] || translations.en;

  // AUTO SLIDE
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  const currentBanner = banners[index];

  return (
    <div className="banner">
      <img
        src={currentBanner.image}
        alt={t[currentBanner.titleKey]}
      />

      <div className="banner-overlay">
        <h2>{t[currentBanner.titleKey]}</h2>

        <p>{t[currentBanner.subtitleKey]}</p>
      </div>
    </div>
  );
};

export default Banner;